'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirlineSeatFlat = function MdAirlineSeatFlat(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.9 20.2q-1.5 1.4-3.5 1.5t-3.6-1.5-1.5-3.5 1.5-3.5 3.5-1.5 3.5 1.4 1.5 3.5-1.4 3.6z m-8.5 3.2h33.2v3.2h-10v3.4h-13.2v-3.4h-10v-3.2z m33.2-5v3.2h-21.6v-10h15q2.7 0 4.7 2t1.9 4.8z' })
        )
    );
};

exports.default = MdAirlineSeatFlat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airline-seat-flat.js
// module id = 447
// module chunks = 0